import i18n from 'i18n'
import { all, takeEvery, put, select } from 'redux-saga/effects'
import localforage from 'myStore'
import qs from 'qs'
import { history, store as reduxStore } from 'index'
import { getAvailableLocale } from 'localization'

import actions from './actions'

export function* CHANGE_SETTING({ payload: { setting, value, save } }) {
  const saveSetting = async () => {
    await localforage.setItem(`app.settings.${setting}`, value)
  }

  if (save !== false) {
    yield saveSetting()
  }

  yield put({
    type: 'settings/SET_STATE',
    payload: {
      [setting]: value,
    },
  })
}

export function* SET_PRIMARY_COLOR({ payload: { color } }) {
  const addStyles = () => {
    const styleElement = document.querySelector('#primaryColor')
    if (styleElement) {
      styleElement.remove()
    }
    const body = document.querySelector('body')
    const styleEl = document.createElement('style')
    const css = document.createTextNode(`:root { --kit-color-primary: ${color};}`)
    styleEl.setAttribute('id', 'primaryColor')
    styleEl.appendChild(css)
    body.appendChild(styleEl)
  }

  yield addStyles()
  yield reduxStore.dispatch({
    type: 'settings/CHANGE_SETTING',
    payload: {
      setting: 'primaryColor',
      value: color,
    },
  })
}

export function* SET_THEME({ payload: { theme } }) {
  const nextTheme = theme === 'light' ? 'light' : 'dark'
  yield document.querySelector('html').setAttribute('data-kit-theme', nextTheme)
  yield reduxStore.dispatch({
    type: 'settings/CHANGE_SETTING',
    payload: {
      setting: 'theme',
      value: nextTheme,
    },
  })
}

export function* SET_LOCALE({ payload: { locale } }) {
  const availableLocale = getAvailableLocale(locale)

  yield reduxStore.dispatch({
    type: 'settings/CHANGE_SETTING',
    payload: {
      setting: 'locale',
      value: availableLocale,
    },
  })

  i18n.changeLanguage(availableLocale, () => {
    reduxStore.dispatch({
      type: 'menu/RELOAD',
    })

    // reduxStore.dispatch({
    //   type: 'settings/CHANGE_SETTING',
    //   payload: {
    //     setting: 'logo',
    //     value: str,
    //   },
    // })
  })
}

export function* SET_TRANSITION({ payload: { routerAnimation, path } }) {
  const { routerAnimation: oldValue } = yield select((state) => state.settings)

  if (routerAnimation != null) {
    yield reduxStore.dispatch({
      type: 'settings/CHANGE_SETTING',
      payload: {
        setting: 'routerAnimation',
        value: routerAnimation,
        save: false,
      },
    })
  }

  if (path != null) {
    yield history.push(path)
  }

  if (oldValue != null) {
    yield reduxStore.dispatch({
      type: 'settings/CHANGE_SETTING',
      payload: {
        setting: 'routerAnimation',
        value: oldValue,
        save: false,
      },
    })
  }
}

export function* SETUP() {
  // load settings from url on app load
  const changeSettings = (search) => {
    const query = qs.parse(search, { ignoreQueryPrefix: true })
    Object.keys(query).forEach((key) => {
      let value
      switch (query[key]) {
        case 'false':
          value = false
          break
        case 'true':
          value = true
          break
        default:
          value = query[key]
          break
      }
      if (key === 'theme') {
        reduxStore.dispatch({
          type: 'settings/SET_THEME',
          payload: {
            theme: value,
          },
        })
        return
      } else if (key === 'locale' || key === 'lang') {
        reduxStore.dispatch({
          type: 'settings/SET_LOCALE',
          payload: {
            locale: value,
          },
        })
        return
      } else if (key === 'key') {
        reduxStore.dispatch({
          type: 'user/LOGIN_WITH_KEY',
          payload: {
            key: value,
          },
        })
        return
      }

      // 미리 정의된 키가 아니면 search parameter로 들어온 값은 저장하지 않는다.
      // reduxStore.dispatch({
      //   type: 'settings/CHANGE_SETTING',
      //   payload: {
      //     setting: key,
      //     value,
      //   },
      // })
    })
  }
  yield changeSettings(history.location.search)
  yield history.listen((sparams) => {
    const { search } = sparams
    changeSettings(search)
  })

  // set primary color on app load
  const primaryColor = async () => {
    const color = await localforage.getItem('app.settings.primaryColor')
    if (color) {
      reduxStore.dispatch({
        type: 'settings/SET_PRIMARY_COLOR',
        payload: {
          color,
        },
      })
    }
  }
  yield primaryColor()

  // init theme on app load
  const initTheme = async () => {
    const { search } = history.location
    const query = qs.parse(search, { ignoreQueryPrefix: true })
    const theme = query.theme || (await localforage.getItem('app.settings.theme')) || 'default'
    reduxStore.dispatch({
      type: 'settings/SET_THEME',
      payload: {
        theme,
      },
    })
  }
  yield initTheme()

  const initLocale = async () => {
    const locale = await localforage.getItem('app.settings.locale')
    if (locale) {
      reduxStore.dispatch({
        type: 'settings/CHANGE_SETTING',
        payload: {
          setting: 'locale',
          value: locale,
        },
      })
    }
  }
  yield initLocale()

  // detect isMobileView setting on app load and window resize
  const isMobileView = async (load = false) => {
    const currentState = global.window.innerWidth < 1108
    const prevState = await localforage.getItem('app.settings.isMobileView')
    if (currentState !== prevState || load) {
      reduxStore.dispatch({
        type: 'settings/CHANGE_SETTING',
        payload: {
          setting: 'isMobileView',
          value: currentState,
          // value: false,
        },
      })
    }
  }

  // detect viewport width on app load and window resize
  const isMenuToggled = async () => {
    const shouldToggle = global.window.innerWidth < 1024
    const prevState = await localforage.getItem('app.settings.isMenuCollapsed')
    if (shouldToggle || prevState) {
      reduxStore.dispatch({
        type: 'settings/CHANGE_SETTING',
        payload: {
          setting: 'isMenuCollapsed',
          value: true,
        },
      })
    }
  }

  yield isMobileView(true)
  yield isMenuToggled()
  yield window.addEventListener('resize', () => {
    isMobileView()
    isMenuToggled()
  })
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.CHANGE_SETTING, CHANGE_SETTING),
    takeEvery(actions.SET_PRIMARY_COLOR, SET_PRIMARY_COLOR),
    takeEvery(actions.SET_THEME, SET_THEME),
    takeEvery(actions.SET_LOCALE, SET_LOCALE),
    takeEvery(actions.SET_TRANSITION, SET_TRANSITION),
    SETUP(), // run once on app load to init listeners
  ])
}
